
import { defineComponent, reactive, ref, onMounted, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "reported-hours-statistics-widget",
  setup() {
    const store = useStore();
    const key = ref<number>(0);

    const data = computed(
      () => store.getters["StatisticsModule/reportedHoursStatistic"]
    );
    const chart = reactive({
      data: [
        {
          name: "Reported hours",
          data: [] as string | unknown
        }
      ],
      options: {
        chart: {
          height: 350,
          type: "area",
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        noData: {
          text: "Loading..."
        },
        xaxis: {
          type: "category",
          categories: [] as string[]
        },
        tooltip: {
          x: {
            format: "MMM yyyy"
          }
        }
      }
    });
    const setData = () => {
      chart.options.xaxis.categories = Object.keys(data.value.hours);
      chart.data[0].data = Object.values(data.value.hours);
      key.value++;
    };
    function fetchStatistics() {
      store.dispatch("StatisticsModule/reportedHours").then(() => {
        setData();
      });
    }
    onMounted(() => {
      fetchStatistics();
    });
    return {
      chart,
      data,
      key
    };
  }
});
